module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Assignment Tracking")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Tracking Status")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "direct-chat-messages",
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "your_div"
    }
  }, _vm._l((_vm.clientChat), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding": "0",
        "margin": "0"
      },
      attrs: {
        "id": 'check' + index
      }
    }, [_c('div', {
      staticClass: "direct-chat-msg",
      class: item.clientId != '0' ? 'right' : ''
    }, [_c('div', {
      staticClass: "direct-chat-info clearfix"
    }, [_c('span', {
      staticClass: "direct-chat-name",
      class: item.clientId != '0' ? 'pull-right' : 'pull-left'
    }, [_vm._v(_vm._s(item.clientId == "0" ? "Pridel Team" : "You"))]), _vm._v(" "), _c('span', {
      staticClass: "direct-chat-timestamp",
      class: item.clientId != '0' ? 'pull-left' : 'pull-right'
    }, [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])]), _vm._v(" "), _c('img', {
      staticClass: "direct-chat-img",
      attrs: {
        "src": "https://image.flaticon.com/icons/svg/149/149452.svg",
        "alt": "message user image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "direct-chat-text"
    }, [_vm._v(_vm._s(item.remarkMsg))])])])
  }))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('b-form-textarea', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.updateModal.remarkMsg),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "remarkMsg", $$v)
      },
      expression: "updateModal.remarkMsg"
    }
  }), _vm._v(" "), (!_vm.updateModal.remarkMsg) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.remarkMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.sendUpdate
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215e0bef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientDashboard/clientChatScreen.vue
// module id = 2456
// module chunks = 0